import { useNavigate } from "react-router-dom";
import { useEffect, useState } from 'react';
import { fetchUserBeats } from 'Service/ApiService';

const BeatsController = () => {
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem('user'));
  const [cloading, setCloading] = useState(false);
  const [beats, setBeats] = useState([]);
  const today = new Date().toISOString().split('T')[0];
  const [selectedDate, setSelectedDate] = useState(today);

  useEffect(() => {
    getUserBeats();
  }, []);

  useEffect(() => {
    getUserBeats();
  }, [selectedDate]);

  const getUserBeats = async () => {
    try {
      setCloading(true);

      const response = await fetchUserBeats(user.userCode, selectedDate);

      if (response) {
        if (response.success == true) {
          setBeats(response.data);
          setCloading(false);
        }
        else {
          setBeats(response.data);
          setCloading(false);
        }
      }
      else {
        setBeats(response.data);
        setCloading(false);
      }
    } catch (error) {
      setCloading(false);
      console.error('Error fetching beats:', error);
    }
  }

  const showCustomers = (beatCode) => {
    navigate(`/beat-customers`, { state: { beatCode, selectedDate } });
  };

  return {
    cloading,
    beats,
    selectedDate,
    setSelectedDate,
    showCustomers,

  };
};

export default BeatsController;
